module.exports = __webpack_public_path__ + "img/license_image1.3497f440.png";